class EventQueue {
  constructor(updateProgressCallback, handleEvent, toggleProgressBarCallback) {
    this.queue = [];
    this.processing = false;
    this.totalEvents = 0;
    this.updateProgressCallback = updateProgressCallback;
    this.handleEvent = handleEvent;
    this.toggleProgressBarCallback = toggleProgressBarCallback;
  }

  enqueue(event) {
    if (this.queue.length === 0) {
      this.toggleProgressBarCallback(true);
    }

    this.queue.push(event);
    this.totalEvents++;
    this.updateProgress();
    this.process();
  }

  async process() {
    if (this.processing || this.queue.length === 0) {
      if (this.queue.length === 0) {
        this.toggleProgressBarCallback(false);
      }
      return;
    }
    this.processing = true;

    try {
      const event = this.queue.shift();
      await this.handleEvent(event);
    } catch (error) {
      console.error('Error processing event:', error);
    } finally {
      this.processing = false;
      this.updateProgress();

      if (this.queue.length === 0) {
        this.toggleProgressBarCallback(false);
      } else {
        this.process();
      }
    }
  }

  updateProgress() {
    const processedEvents = this.totalEvents - this.queue.length;
    const progress = Math.min((processedEvents / this.totalEvents) * 100, 100);

    if (this.updateProgressCallback) {
      this.updateProgressCallback(progress);
    }
  }
}

export default EventQueue;
